import { render, staticRenderFns } from "./EditGroupName.vue?vue&type=template&id=0bf7e419&scoped=true&"
import script from "./EditGroupName.vue?vue&type=script&lang=js&"
export * from "./EditGroupName.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupName.vue?vue&type=style&index=0&id=0bf7e419&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7e419",
  null
  
)

component.options.__file = "EditGroupName.vue"
export default component.exports